export default __webpack_public_path__ + "static/media/jewelryProject.10f694d8.png";